<template>
  <div class="mc-widget-call__call-item-container">
    <div class="mc-widget-call__vehicle-information">
      <h5 class="mc-widget-call__licenseplate" :title="licensePlate">
        {{ licensePlate }}
      </h5>
      <p class="mc-widget-call__driver" :title="driver ?? $t('global.text.noDriver')">
        {{ driver ?? $t('global.text.noDriver') }}
      </p>
    </div>

    <div class="mc-widget-call__voice-action-container">
      <div class="mc-widget-call__voice-information">
        <span> {{ formattedTime }} </span>
        <span v-if="muted" class="mc-widget-call__muted-label">
          <!-- eslint-disable-next-line i18next/no-literal-string -->
          <i class="mc-fa icon-outline_mic-off"></i> Muted
        </span>
        <span v-else>
          <voice-animation />
        </span>
      </div>
      <div class="mc-widget-call__more-options-container">
        <b-dropdown
          variant="black"
          menu-class="p-0"
          toggle-class="btn btn-more-options btn-outline-primary"
        >
          <template #button-content>
            <i class="mc-fa icon-outline_more-vertical"></i>
          </template>
          <b-dropdown-item v-if="deviceType !== 'vss-howen'" @click="toggleMute()">
            <i v-show="muted" class="mc-fa icon-outline_mic"></i>
            <i v-show="!muted" class="mc-fa icon-outline_mic-off"></i>
            <span>
              {{ muted ? $t('trackVideo.unmuteVehicle') : $t('trackVideo.muteVehicle') }}
            </span>
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('stopCall')">
            <i class="mc-fa icon-outline_phone-off"></i>
            <span>
              {{ $t('trackVideo.end') }}
            </span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import VoiceAnimation from '../VoiceAnimation.vue'
export default {
  name: 'OnGoing',
  components: {
    VoiceAnimation,
  },
  props: {
    licensePlate: {
      type: String,
      required: true,
    },
    driver: {
      type: String,
      required: false,
      default: '',
    },
    vehicleId: {
      type: Number,
      required: true,
    },
    muted: {
      type: Boolean,
      required: true,
    },
    deviceType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      time: 0, // Initialize time (in milliseconds)
      intervalTime: null,
    }
  },
  computed: {
    // Compute formatted time (hours:minutes:seconds)
    formattedTime() {
      const hours = String(Math.floor(this.time / 3600000)).padStart(2, '0')
      const minutes = String(Math.floor((this.time % 3600000) / 60000)).padStart(2, '0')
      const seconds = String(Math.floor((this.time % 60000) / 1000)).padStart(2, '0')
      return `${hours}:${minutes}:${seconds}`
    },
  },
  mounted() {
    // Start the interval to update the time every millisecond
    this.intervalId = setInterval(() => {
      this.time += 1000 // Increment time by 1000 milliseconds (1 second)
    }, 1000)
  },
  beforeDestroy() {
    // Clear the interval when the component is destroyed to avoid memory leaks
    clearInterval(this.intervalId)
  },

  methods: {
    toggleMute() {
      if (this.muted) {
        this.$emit('unmuteDevice')
      } else {
        this.$emit('muteDevice')
      }
    },
  },
}
</script>
